import { Injectable } from '@angular/core';

import DomainEventProvider from '../../../../../core/domain/events/domain_event_provider';
import { BillEvent } from './bill-events';

@Injectable({ providedIn: 'root' })
export class BillEventProvider extends DomainEventProvider<BillEvent> {}
